import { ISelectable } from "../tools/selectable";

export class SamplingPoint extends ISelectable {

    Code: string;
    Name: string;
    Address: string;
    AdditionalAddress: string;
    City: string;
    ZipCode: string;

    static mapFromJSON(json): SamplingPoint {
        const sp = new SamplingPoint;

        sp.Code = json['code'];
        sp.Name = json['name'];
        sp.Address = json['address'];
        sp.City = json['city'];
        sp.ZipCode = json['zipCode'];
        sp.AdditionalAddress = json['additionalAddress'];

        return sp;
    }
}
